export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function currentMonthKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function shiftMonth(monthKey, delta) {
  const [y, m] = monthKey.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function pickDefaultDay(monthKey) {
  const today = todayIso();
  if (today.startsWith(monthKey)) return today;
  return `${monthKey}-01`;
}

export function formatDisplayDate(iso) {
  if (!iso) return "—";
  return new Date(`${iso}T12:00:00`).toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function shortWeekday(iso) {
  if (!iso) return "";
  return new Date(`${iso}T12:00:00`).toLocaleDateString("en-IN", { weekday: "short" });
}

export function dayOfMonth(iso) {
  if (!iso) return "";
  return new Date(`${iso}T12:00:00`).getDate();
}

/** Days in monthKey (YYYY-MM) as ISO strings. */
export function daysInMonthIso(monthKey) {
  const [y, m] = monthKey.split("-").map(Number);
  const days = new Date(y, m, 0).getDate();
  return Array.from({ length: days }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return `${monthKey}-${day}`;
  });
}
